import { render, staticRenderFns } from "./menu-builder.vue?vue&type=template&id=708a1526&scoped=true&"
import script from "./menu-builder.vue?vue&type=script&lang=js&"
export * from "./menu-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a1526",
  null
  
)

export default component.exports